import { ITEM_KINDS, STATES } from '../../../constants';

const PAGE_TITLE = 'Red Cross Disaster Relief';

export function RedCrossConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_RED_CROSS, {
    url: '/red-cross',
    views: {
      '@': {
        template: `<upd-red-cross></upd-red-cross>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    titleBar: {
      title: PAGE_TITLE,
      icon: 'redcross',
    },
    analytics: {
      page: 'Red Cross',
    },
    data: {
      moveItem: {
        type: ITEM_KINDS.RED_CROSS,
        singleton: true,
      },
    },
  });
}
